@if (myLeads$ | async; as assignedLeads) {
  <div class="assigned-leads-header">
    <div class="page-heading">
      <div class="page-title">My Leads</div>
      <div class="page-subtitle">
        Review and manage the leads currently assigned to your CDFI.
      </div>
    </div>
    @if (assignedLeads.length > 0) {
      <div class="page-size">
        <app-page-size
          [pageSize]="pageSize"
          [selectId]="'assigned-leads'"
          (pageSizeChanged)="onPageSizeChange($event)"
        ></app-page-size>
      </div>
    }
  </div>
  <div class="filter-search-section">
    <div class="page-filter" id="tour-lead-filter">
      <app-filter
        [label]="'Lead status:'"
        [filterBy]="filterBy"
        [filterByOptions]="filterByOptions"
        (filterByChanged)="onFilterByChange($event)"
      ></app-filter>
    </div>

    <div class="search-section-wrapper" id="tour-lead-search">
      <app-search-input
        [placeholder]="'Search Business ...'"
        [(searchQuery)]="searchQuery"
        (searchQueryChange)="onSearchQueryChange($event)"
      ></app-search-input>
    </div>
  </div>
  <div class="assigned-leads-wrapper" [class.has-right-section]="showWebMap">
    <div class="left-section" [class.full-width]="!showWebMap">
      @if (assignedLeads.length > 0) {
        <div class="all-section">
          <label class="checkbox-container">
            <input
              type="checkbox"
              [(ngModel)]="allChecked"
              (change)="onAllCheckBoxChange(assignedLeads)"
            />
            <span class="checkmark"></span>
            <span class="label-text">All</span>
          </label>
          @if (selectedLeads.length > 0) {
            <div class="right-section-buttons">
              <a
                href="javascript:void(0)"
                class="show-in-map"
                (click)="onShowInMap()"
                >Show In Map</a
              >
              <!-- <div class="right-button-wrapper">
                <div class="icap">
                  <span>ICAP</span> -->
              <!-- <div class="arrow-down"></div> -->
              <!-- </div>
                <a
                  href="javascript:void(0)"
                  class="enquiry-form"
                  (click)="onGenerateInquiryForm()"
                  >Generate Inquiry Form</a
                >
              </div> -->
            </div>
          }
        </div>

        <div class="results-wrapper">
          @for (lead of assignedLeads; let i = $index; track $index) {
            <div [id]="'tour-lead-item-' + i">
              <app-assigned-lead-row
                [rowId]="i"
                [assignedLead]="lead"
                [recordUniqueId]="lead.unique_id"
                [checked]="allChecked || selectedLeads.includes(lead)"
                [assignedToMe]="lead.assigned_to?.username === loggedInUser"
                (leadCheckedEmitter)="onLeadChecked($event)"
                (showDetailViewEmitter)="showDetailView($event)"
                (unassignLeadEmitter)="onUnassignLead($event)"
              ></app-assigned-lead-row>
            </div>
          }
        </div>
        <app-pagination
          [currentPage]="currentPage"
          [pageSize]="pageSize"
          [totalItems]="totalLeads"
          (pageChanged)="onPageChange($event)"
        ></app-pagination>
      } @else {
        <div class="no-data-wrapper">
          <div class="no-data">
            <div class="icon-holder">
              <app-svg-icon
                [iconName]="'no-data.svg'"
                [height]="'100px'"
                [width]="'100px'"
              ></app-svg-icon>
            </div>
            <div class="text-holder">No Data Available</div>
          </div>
        </div>
      }
    </div>
    @if (showWebMap) {
      <div class="right-section">
        <div class="close-instruction-wrapper">
          <a
            href="javascript:void(0)"
            class="close-instruction"
            title="Close Map"
            (click)="showWebMap = !showWebMap"
          >
            <app-svg-icon
              [iconName]="'close.svg'"
              [height]="'20px'"
              [width]="'20px'"
              [style.fill]="'#666'"
            ></app-svg-icon>
          </a>
        </div>
        @defer (when showWebMap; prefetch on idle) {
          <app-arcgis-webmap (mapReady)="onMapReady()"></app-arcgis-webmap>
        } @placeholder {
          <div class="map-skeleton">
            <div class="skeleton-box"></div>
          </div>
        }
      </div>
    }
  </div>
} @else {
  <div class="assigned-leads-header">
    <div class="page-heading">
      <div class="page-title">My Leads</div>
      <div class="page-subtitle">
        Review and manage the leads currently assigned to your CDFI.
      </div>
    </div>
  </div>
  <div class="assigned-leads-wrapper">
    <div class="left-section full-width">
      <div class="all-section" style="min-height: 68px"></div>
      <div class="results-wrapper">
        <div class="each-result">
          <div class="checkbox-section">
            <label class="checkbox-container">
              <input type="checkbox" disabled /><span class="checkmark"></span>
            </label>
            <a href="javascript:void(0)" class="leads-link">
              <div class="id">
                <div class="skeleton-box"></div>
              </div>
              <div class="name">
                <div class="skeleton-box"></div>
              </div>
              <div class="location">
                <div class="skeleton-box"></div>
              </div>
            </a>
          </div>
          <div class="section-with-menu-arrow">
            <a href="javascript:void(0)" class="right-arrow"> </a>
          </div>
        </div>
        <div class="each-result">
          <div class="checkbox-section">
            <label class="checkbox-container">
              <input type="checkbox" disabled /><span class="checkmark"></span>
            </label>
            <a href="javascript:void(0)" class="leads-link">
              <div class="id">
                <div class="skeleton-box"></div>
              </div>
              <div class="name">
                <div class="skeleton-box"></div>
              </div>
              <div class="location">
                <div class="skeleton-box"></div>
              </div>
            </a>
          </div>
          <div class="section-with-menu-arrow">
            <a href="javascript:void(0)" class="right-arrow"> </a>
          </div>
        </div>
        <div class="each-result">
          <div class="checkbox-section">
            <label class="checkbox-container">
              <input type="checkbox" disabled /><span class="checkmark"></span>
            </label>
            <a href="javascript:void(0)" class="leads-link">
              <div class="id">
                <div class="skeleton-box"></div>
              </div>
              <div class="name">
                <div class="skeleton-box"></div>
              </div>
              <div class="location">
                <div class="skeleton-box"></div>
              </div>
            </a>
          </div>
          <div class="section-with-menu-arrow">
            <a href="javascript:void(0)" class="right-arrow"> </a>
          </div>
        </div>
      </div>
    </div>
  </div>
}

@if (showConfirmPopup) {
  <app-unassign-lead-popup
    [leadName]="popupLead.company_name"
    [leadUniqueId]="popupLead.unique_id"
    [currentStatus]="getLeadCurrentStatus(popupLead)"
    [statusNotes]="popupLead.lead_attributes?.['status_notes'] || ''"
    [leadAttributes]="popupLead.lead_attributes"
    [isSubmitting]="isUnassigning"
    (confirm)="OnConfirmUnassign($event)"
    (cancel)="showConfirmPopup = false"
  ></app-unassign-lead-popup>
}

@if (showLeadDetails) {
  <app-record-details
    [company]="selectedLeadForDetailView"
    (popupClosed)="hideDetailView()"
    (companyDetailsUpdated)="onCompanyDetailsUpdated($event)"
    (companyDeleted)="onCompanyDeleted($event)"
    (leadStatusUpdated)="onLeadStatusUpdated($event)"
  ></app-record-details>
}

@if (showInquiryPopup) {
  <app-inquiry-form-links
    [Leads]="selectedLeads"
    (popupClosed)="hideInquiryPopup()"
  ></app-inquiry-form-links>
}
